import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import logoImg from "../../assets/imgs/pratham_logo.jpg";
import "../../assets/css/app.css";
import fb from "../../assets/imgs/icons/fb_icon.svg";
import insta from "../../assets/imgs/icons/insta_icon.svg";
import link from "../../assets/imgs/icons/link_icon.svg";
import categories from "../../assets/Data/categories";
import "./Header.css";

const Header = () => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(window.scrollY);
  const [hideTopHeader, setHideTopHeader] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setHideTopHeader(true);
      } else {
        setHideTopHeader(false);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleNavClick = () => {
    setMenuOpen(false);
    setDropdownVisible(false); 
  };

  const handleDropdownClick = (e) => {
    e.preventDefault(); 
    setDropdownVisible(!isDropdownVisible); 
  };

  return (
    <div className="hdrCntnr">
      <div className={`socIcons ${hideTopHeader ? "hide-top-header" : ""}`}>
        <img src={fb} alt="Facebook" />
        <img src={link} alt="LinkedIn" />
        <a 
  href="https://www.instagram.com/prathamstyle89" 
  target="_blank" 
  rel="noopener noreferrer"
>
  <img src={insta} alt="Instagram" />
</a>


      </div>

      <header className={`header ${hideTopHeader ? "move-up" : ""}`}>
        <div className="maxW">
          <div className="hdrMain">
            <div className="logo">
              <NavLink to="/" className="hme">
                <button style={{ all: "unset" }}>
                  <img src={logoImg} alt="Pratham Style" />
                </button>
              </NavLink>
            </div>

            <div className={`hamburger ${menuOpen ? "open" : ""}`} onClick={toggleMenu}>
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
            </div>

            <nav className={`navLft ${menuOpen ? "active" : ""}`}>
              <div className="navWrp">
                <div className={`NavList ${menuOpen ? "slide-in" : "slide-out"}`}>
                  <NavLink to={"/"} className="hme" onClick={handleNavClick}>
                    HOME
                  </NavLink>
                  <NavLink to={"/AboutUs"} className="hme" onClick={handleNavClick}>
                    ABOUT US
                  </NavLink>

                  <div className="prodList">
                    <a className="droptogg" href="#" onClick={handleDropdownClick}>
                      PRODUCTS
                    </a>

                    {isDropdownVisible && (
                      <div className="dropMnu">
                        {categories.map((category) => (
                          <NavLink
                            to={`/Product/${category.catId}`}
                            key={category.catId}
                            className="dropItm"
                            onClick={handleNavClick}
                          >
                            <img src={category.headerImg} alt={category.title} className="dropImg" />
                            <span>{category.title}</span>
                          </NavLink>
                        ))}
                      </div>
                    )}
                  </div>

                  <NavLink to={"/ContactUs"} className="hme" onClick={handleNavClick}>
                    CONTACT US
                  </NavLink>
                  <div className="header-right">
                    <NavLink to={"/Enquiry"} className="enquiry-btn" onClick={handleNavClick}>
                      ENQUIRY
                    </NavLink>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
